import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import route from '../../utils/Routes';
import { useAuthContext } from '../../context/AuthContext';
import constants from '../../utils/Constants';

function HomePage() {
    const { ctxtUser, setLoadingScreen } = useAuthContext();
    const navigate = useNavigate();
    useEffect(() => {
        setLoadingScreen(true);
        if (ctxtUser?.token) {
            if (ctxtUser?.isComUser === true)
                navigate(route.comDashboard, { replace: true });
            else if (ctxtUser?.userType === constants.accounts)
                navigate(route.aPolist, { replace: true });
            else
                navigate(route.adminDash, { replace: true });
        }
        else
            navigate(route.login, { replace: true });
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<div>HomePage</div>)
}

export default HomePage
